import { useMount } from "constants/constants";
import { atom, useAtom } from "jotai";
import { SetStateAction } from "react";
import { useIsStorybook } from "utils/customHooks/storyHooks";

const displayTimelinePageTimelinesAtom = atom(
  window.location.pathname.includes("fromSnapshots")
);
export function useDisplayTimelinePageTimelines(): [
  boolean,
  (update: SetStateAction<boolean>) => void | Promise<void>,
] {
  const [displayTimelinePageTimelines, setDisplayTimelinePageTimelines] =
    useAtom(displayTimelinePageTimelinesAtom);
  const isStorybook = useIsStorybook();
  useMount(() => {
    if (isStorybook) {
      setDisplayTimelinePageTimelines(true);
    }
  });

  return [displayTimelinePageTimelines, setDisplayTimelinePageTimelines];
}
